import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All PERMISSION SERVICE
export const getPermissionsService = createAsyncThunk(
  "general/getPermissionsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.permissionsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All NOTIFICATIONS SERVICE
export const getNotificationsService = createAsyncThunk(
  "general/getNotificationsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.notificationsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All NOTIFICATIONS SERVICE
export const getNotificationsInfoService = createAsyncThunk(
  "general/getNotificationsInfoService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.notificationsInfoURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
//
// GET =>  All STATISTICS SERVICE
export const getStatisticsService = createAsyncThunk(
  "general/getStatisticsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.statisticsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE USER SERVICE
export const createContactUservice = createAsyncThunk(
  "general/createUserService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.contactUsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE USER SERVICE
export const createNotificationService = createAsyncThunk(
  "general/createNotifictionService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.notificationsInfoURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET ALL CONTACT USER SERVICE
export const getAllContactUSerService = createAsyncThunk(
  "general/getAllContactUSerService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.contactUsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET PRIVACY POLICY SERVICE
export const getCmsService = createAsyncThunk(
  "general/getCmsService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.cmsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);


// POST =>  POST 
export const uploadImageService = createAsyncThunk(
  "general/uploadImageService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.uploadImageURL,data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// POST =>  CREATE CMS SERVICE
export const createCmsService = createAsyncThunk(
  "general/createCmsService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.cmsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// GET =>  GET DISCOUNT CODE SERVICE
export const getDiscountCouponsService = createAsyncThunk(
  "general/getDiscountCouponsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.discountCouponsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE DISCOUNT CODE SERVICE
export const createDiscountCodeService = createAsyncThunk(
  "general/createDiscountCodeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.discountCouponsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE PRODUCT SERVICE
export const updateDiscountCodeModal = createAsyncThunk(
  "general/updateCouponModal",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.discountCouponsURL}/${params?.id}`,
        params.formData,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE DISOUNT CODE SERVICE
export const deleteDiscountCodeService = createAsyncThunk(
  "general/deleteDiscountCodeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.discountCouponsURL}/${params?.id}`,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All ADVERTISMENT SERVICE
export const getAdvertisementsService = createAsyncThunk(
  "general/getAdvertisementsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.advertisementsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE ADVERTISMENT SERVICE
export const createAdvertismentService = createAsyncThunk(
  "general/createAdvertismentService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.advertisementsURL, data?.data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE ADVE SERVICE
export const updateAdvertisementService = createAsyncThunk(
  "general/updateAdvertisementService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(
        `${URLS.advertisementsURL}/${params?.id}/update`,
        params.formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE ADVERTISMENT SERVICE
export const deleteAdvertismentService = createAsyncThunk(
  "general/deleteAdvertismentService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.advertisementsURL}/${id}`,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All STORE INFO  SERVICE
export const getStoreInfoService = createAsyncThunk(
  "general/getStoreInfoService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.storeInfoURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET ALL GOVER  SERVICE
export const getAllgovernoratesService = createAsyncThunk(
  "general/getAllgovernoratesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.governoratesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE Governorates SERVICE
export const createGovernoratesService = createAsyncThunk(
  "general/createGovernoratesService",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await axios.post(URLS.governoratesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE Governorates SERVICE
export const deleteGovernoratesService = createAsyncThunk(
  "general/deleteGovernoratesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.governoratesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE Governorates SERVICE
export const updateGovernoratesService = createAsyncThunk(
  "general/updateGovernoratesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.governoratesURL}/${params?.id}`,
        params?.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET AREA BY GOV
export const getAreaByGovService = createAsyncThunk(
  "general/getAreaByGovService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.areasURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE AREA SERVICE
export const createAreaService = createAsyncThunk(
  "general/createGovernoratesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.areasURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE AREA SERVICE
export const deleteAreaService = createAsyncThunk(
  "general/deleteAreaService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.areasURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE AREA SERVICE
export const updateAreaService = createAsyncThunk(
  "general/updateGovernoratesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.areasURL}/${params?.id}`,
        params?.formData,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE Shipping  SERVICE
export const createShippingSettingService = createAsyncThunk(
  "general/createShippingSettingService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.shippingSettingsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET Shipping  SERVICE
export const getShippingByIdService = createAsyncThunk(
  "general/getShippingByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.shippingSettingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET Shipping  SERVICE
export const getShippingService = createAsyncThunk(
  "general/getShippingService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(URLS.shippingSettingsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE SHIPPING SERVICE
export const deleteShippingService = createAsyncThunk(
  "general/deleteShippingService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.shippingSettingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE SHIPPING SERVICE
export const updateShippingService = createAsyncThunk(
  "general/updateShippingService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.shippingSettingsURL}/${params?.id}`,
        params?.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
